import { render, staticRenderFns } from "./PembelianUpdate.vue?vue&type=template&id=140d99de&scoped=true&"
import script from "./PembelianUpdate.vue?vue&type=script&lang=js&"
export * from "./PembelianUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PembelianUpdate.vue?vue&type=style&index=0&id=140d99de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d99de",
  null
  
)

export default component.exports